import type { ProposedEditData } from '@/components/layout/chat-pane.types'

/** Match a proposed edit to a message row (sessionEditId when present, else documentId). */
export function proposedEditMatches(
  a: ProposedEditData | null | undefined,
  b: ProposedEditData | null | undefined,
): boolean {
  if (!a || !b) return false
  if (a.sessionEditId && b.sessionEditId) return a.sessionEditId === b.sessionEditId
  return a.documentId === b.documentId
}

export function isPendingProposedEdit(pe: ProposedEditData | null | undefined): boolean {
  if (!pe || !pe.documentId) return false
  if (pe.status === 'accepted' || pe.status === 'rejected') return false
  if (pe.requiresAcceptance === false) return false
  const original = pe.original ?? ''
  const proposed = pe.proposed ?? ''
  if (!original && !proposed) return false
  if (original === proposed) return false
  return true
}
